import { useEffect, useState } from "react";
import { Coins } from "lucide-react";
import { api } from "@/lib/api";
import BudgetBar from "./BudgetBar";

const eur = (v) => (v == null ? "—" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: v > 0 && v < 1 ? 3 : 2 }).format(v));
const tokens = (n) => (n >= 1e6 ? `${(n / 1e6).toFixed(2)}M` : n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n));

function Tile({ label, value, sub, testid, accent }) {
  return (
    <div className={`border-2 border-foreground p-3 ${accent ? "bg-primary text-primary-foreground" : "bg-background"}`} data-testid={testid}>
      <div className="font-display uppercase text-[10px] tracking-widest opacity-80">{label}</div>
      <div className="font-mono-num font-bold text-xl mt-0.5">{value}</div>
      {sub && <div className={`text-[11px] mt-0.5 ${accent ? "opacity-80" : "text-muted-foreground"}`}>{sub}</div>}
    </div>
  );
}

export default function HelpCostCard({ refreshKey }) {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/help/costs").then((r) => setC(r.data)).catch(() => setC(null)); }, [refreshKey]);
  if (!c) return null;
  const { month, last_30d: last, all, pricing } = c;
  return (
    <div className="border-2 border-foreground bg-muted/30 p-4 space-y-3" data-testid="help-cost-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-display font-black uppercase tracking-tight inline-flex items-center gap-2"><Coins className="w-4 h-4" /> AI-kosten helpchat</h3>
        <span className="text-[11px] text-muted-foreground">
          Tarief {pricing.model}: ${pricing.usd_per_m_input}/M in · ${pricing.usd_per_m_output}/M uit · $1 = €{String(pricing.usd_to_eur).replace(".", ",")}
        </span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Tile label="Deze maand" value={eur(month.cost_eur)} sub={`${month.questions} vragen · ${tokens(month.input_tokens)} in / ${tokens(month.output_tokens)} uit`} testid="help-cost-month" />
        <Tile label="Laatste 30 dagen" value={eur(last.cost_eur)} sub={`${last.questions} vragen · ${tokens(last.input_tokens)} in / ${tokens(last.output_tokens)} uit`} testid="help-cost-30d" />
        <Tile label="Prognose per maand" value={eur(c.projection_month_eur)} sub="op basis van de laatste 30 dagen" testid="help-cost-projection" accent />
        <Tile label="Gem. per vraag" value={eur(c.per_question_eur)} sub={`totaal ooit ${eur(all.cost_eur)} · ${all.questions} vragen`} testid="help-cost-per-question" />
      </div>
      {all.estimated > 0 && (
        <p className="text-[11px] text-muted-foreground" data-testid="help-cost-estimated-note">
          {all.estimated} van {all.questions} antwoorden zonder tokenregistratie: geschat op tekstlengte (±{pricing.estimated_prompt_tokens} prompt-tokens per vraag).
        </p>
      )}
      <BudgetBar budget={c.budget} onSaved={(b) => setC({ ...c, budget: b })} />
    </div>
  );
}
